/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if I finish a task before the 25 minutes are up?`)
};

const es_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa si termino una tarea antes de que se acaben los 25 minutos?`)
};

const de_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was, wenn ich eine Aufgabe vor Ablauf der 25 Minuten fertig habe?`)
};

const nl_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat als ik een taak afrond voordat de 25 minuten voorbij zijn?`)
};

const fr_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que faire si je termine une tâche avant la fin des 25 minutes ?`)
};

const it_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa succede se finisco un compito prima che i 25 minuti siano scaduti?`)
};

const pt_br2_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se eu terminar uma tarefa antes de os 25 minutos acabarem?`)
};

const pt_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se eu terminar uma tarefa antes de os 25 minutos acabarem?`)
};

const ja_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25分になる前にタスクが終わったらどうすればいいですか？`)
};

const zh_timer_pomodoro_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果任务在25分钟结束前就完成了怎么办？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq4_q", locale)
	if (locale === "en") return en_timer_pomodoro_faq4_q(inputs)
	if (locale === "es") return es_timer_pomodoro_faq4_q(inputs)
	if (locale === "de") return de_timer_pomodoro_faq4_q(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq4_q(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq4_q(inputs)
	if (locale === "it") return it_timer_pomodoro_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq4_q(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq4_q(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq4_q(inputs)
	return zh_timer_pomodoro_faq4_q(inputs)
};